module.exports = __webpack_public_path__ + "img/descontos.b10ce8dd.jpg";